import { faComments, faLifeRing } from '@fortawesome/pro-light-svg-icons';

import './Support.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../shared/components/button/Button';
import { LiveChat } from '../shared/components/live-chat/LiveChat';
import { TiledLink } from '../shared/components/styledComponents/tiledLink/TiledLink';
import { AuthContext } from '../shared/context/auth-context';
import { HeaderNavigation } from '../shared/headerNavigation/HeaderNavigation';
import { useHttpClient } from '../shared/hooks/http-hook';
import { useUserData } from '../shared/hooks/useUserData.ts';
import { getSupportUrl } from './util/getSupportUrl';

export function Support() {
  const { sendRequest } = useHttpClient();
  const { userData } = useUserData();
  const auth = useContext(AuthContext);
  const { t } = useTranslation();
  const [regionForSupport, setRegionForSupport] = useState(null);
  const [isLiveChatVisible, setIsLiveChatVisible] = useState(false);
  const isPamUser = userData?.customFeatureClient?.toLowerCase() === 'pam';
  const supportUrl = getSupportUrl(isPamUser, regionForSupport);
  const pamClientId = userData?.pamClientCode;

  const handleLiveChatClick = () => {
    setIsLiveChatVisible(true);
  };

  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  useEffect(() => {
    const getRegion = async () => {
      try {
        const response = await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/users/support`);
        if (response?.region) {
          setRegionForSupport(response.region?.toUpperCase());
        }
      } catch (err) {}
    };
    getRegion();
  }, [sendRequest]);

  const bringFocusToLiveChatButton = () => {
    const backElement = document.getElementById('live-chat-button');
    if (backElement) {
      backElement.focus();
    }
  };

  return (
    <>
      <h1 className="visuallyHidden">{t('H001')}</h1>
      <div id="main_container" className="foryou health-area support platform">
        <div className="wrap-screen">
          {auth.isLoggedIn && (
            <>
              <HeaderNavigation />

              <div className="support-cont">
                <div className="support-frame" role="group" aria-labelledby="support-title-1">
                  <div className="life-ring-crisis">
                    <FontAwesomeIcon icon={faLifeRing} />
                    <span className="text-wrapper-7">&nbsp;&nbsp;</span>
                    <h2 className="text-wrapper-7 support-title" id="support-title-1">
                      {t('H002')}
                    </h2>
                  </div>
                  <div className="p">{t(`${isPamUser ? 'support.crisisSupport' : 'H005'}`)}</div>
                  <TiledLink
                    to={
                      regionForSupport === 'UK'
                        ? 'https://www.samaritans.org'
                        : 'https://befrienders.org'
                    }
                    className="darkTiledLink support-button"
                    ariaLabel={`${t('H006')} - ${t('external.link.label')}`}
                    isNewTab
                  >
                    {t('H006')}
                  </TiledLink>
                </div>
                <div className="support-frame" role="group" aria-labelledby="support-title-2">
                  <div className="life-ring-crisis">
                    <FontAwesomeIcon icon={faComments} />
                    <span className="text-wrapper-7">&nbsp;&nbsp;</span>
                    <h2 className="text-wrapper-7 support-title" id="support-title-2">
                      {t(`${isPamUser ? 'support.title.pamWellness' : 'H003'}`)}
                    </h2>
                  </div>
                  <div className="p">
                    {t(`${isPamUser ? 'support.subtitle.pamWellness' : 'H007'}`)}
                  </div>
                  <TiledLink
                    to={supportUrl}
                    className="darkTiledLink support-button"
                    isNewTab={!isPamUser}
                    ariaLabel={`${t(`${isPamUser ? 'support.button.pamWellness' : 'H008'}`)}${isPamUser ? '' : ` - ${t('external.link.label')}`}`}
                  >
                    {t(`${isPamUser ? 'support.button.pamWellness' : 'H008'}`)}
                  </TiledLink>
                </div>
                {isPamUser && (
                  <div className="support-frame" role="group" aria-labelledby="support-title-3">
                    <div className="life-ring-crisis">
                      <FontAwesomeIcon icon={faComments} />
                      <span className="text-wrapper-7">&nbsp;&nbsp;</span>
                      <h2 className="text-wrapper-7 support-title" id="support-title-3">
                        {t('support.livechat.title')}
                      </h2>
                    </div>
                    <Button
                      id="live-chat-button"
                      className="darkButton support-button  support-button--wrapped"
                      onClick={handleLiveChatClick}
                      color="dark"
                    >
                      {t('support.startLiveChat')}
                    </Button>
                  </div>
                )}
              </div>
              {isPamUser && (
                <LiveChat
                  customVariables={{ clientId: pamClientId }}
                  isVisible={isLiveChatVisible}
                  onClose={() => {
                    setIsLiveChatVisible(false);
                    bringFocusToLiveChatButton();
                  }}
                />
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}
